<template>
  <div class="signIn">
    <svg xmlns="http://www.w3.org/2000/svg">
      <!-- filterUnits is required to prevent clipping the blur outside the viewBox -->
      <filter id="motion-blur-filter" filterUnits="userSpaceOnUse">
        <!-- We only want horizontal blurring. x: 100, y: 0 -->
        <feGaussianBlur stdDeviation="25 0"></feGaussianBlur>
      </filter>
    </svg>
    <vue-typed-js
      :strings="[
        'again, <br /> if you are already registered with us, <br /> fill out the form and sign in',
        ', <br /> if this is your first time hiring a site, <br /> go to the signup page and register.'
      ]"
      v-if="$vuetify.breakpoint.lgAndUp"
      :loop="true"
      :typeSpeed="100"
      :backSpeed="25"
      :contentType="'html'"
      style="align-self: flex-start; margin: 8%;"
    >
      <h1 class="typed_text" filter-content="W">
        Welcome, glad to see you
        <span class="typing"></span>
      </h1>
    </vue-typed-js>
    <v-flex xs12 sm6 md4 lg3 class="signIn_container">
      <div class="signIn_form">
        <div class="signIn_form-title mb-2">
          Sign in
        </div>
        <transition name="fade">
          <!--Error Alert-->
          <form-alert style="width: 95%;" v-if="error" :message="error.message">
          </form-alert>
        </transition>
        <v-form
          v-model="isFormValid"
          lazy-validation
          ref="form"
          @submit.prevent="handleSigninUser"
          class="signIn_form-flex"
        >
          <v-text-field
            :rules="userEmailRules"
            autocomplete="email"
            v-model.trim="userEmail"
            label="Email"
            prepend-inner-icon="mail"
            placeholder="Enter your email"
            type="text"
            required
            outlined
            dark
            class="signIn_form-email"
          ></v-text-field>
          <v-text-field
            :rules="passwordRules"
            v-model.trim="password"
            label="Password"
            prepend-inner-icon="fa-lock"
            :append-icon="showPass ? 'fa-eye' : 'fa-eye-slash'"
            autocomplete="password"
            placeholder="Enter your password"
            :type="showPass ? 'text' : 'password'"
            required
            outlined
            dark
            class="signIn_form-pass"
            @click:append="showPass = !showPass"
          >
          </v-text-field>
          <v-btn
            class="ma-2"
            outlined
            color="white"
            style="width: 95%;"
            :disabled="!isFormValid || loading"
            type="submit"
            :loading="loading"
            data-cy="signInButton"
          >
            Sign In
          </v-btn>
          <h3 class="helper_text">
            Don't have an account?
            <router-link to="/auth/signup">Signup</router-link>
          </h3>
          <div class="social_btn_block">
            <v-btn
              v-for="(social, index) in items"
              :key="index"
              class="mx-3"
              dark
              icon
              @click="authenticate(social.provider)"
            >
              <v-icon size="18px">{{ social.icon }}</v-icon>
            </v-btn>
          </div>
        </v-form>
      </div>
    </v-flex>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
//import router from "../../router.js";
import { validationRules } from "../../../constants/global";

export default {
  data() {
    return {
      showPass: "",
      userEmail: "",
      password: "",
      isFormValid: true,
      userEmailRules: validationRules.email,
      wasNotPushed: true,
      passwordRules: [
        password => !!password || "Password is required",
        password =>
          password.length >= 4 || "Password must be at least 4 characters"
      ],
      items: [
        { icon: "fab fa-facebook", provider: "facebook" },
        { icon: "fab fa-twitter", provider: "twitter" },
        { icon: "fab fa-google", provider: "google" },
        { icon: "fab fa-github", provider: "github" }
        //  { icon: "fab fa-instagram", link: "" },
        //  { icon: "fab fa-linkedin", link: "" },
        //  { icon: "fab fa-google-plus", link: "" },
      ]
    };
  },

  computed: {
    ...mapGetters(["loading", "error", "user", "isAuthenticated"])
  },

  watch: {
    user(value) {
      // if user value changes and redirect is populated - redirect to redirect page, otherwise to home lib page
      // var redir_path = !this.$route.query.redirect
      //   ? "/lib/home_lib"
      //   : this.$route.query.redirect;
      if (value && this.wasNotPushed) {
        this.$router.push("/");
        this.wasNotPushed = false;
      }
    }
  },
  methods: {
    handleSigninUser() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("signInUser", {
          userEmail: this.userEmail,
          password: this.password
        });
      }
      //reach out of Vuex store, fire action that gets Clubs
      // this.$store.dispatch("allClubs", {});
    }
  }
};
</script>

<style lang="scss">
.typed_text {
  font-size: 30px;
  font-weight: 900;
  font-family: "Roboto";
  font-style: italic;
  color: white;
  text-transform: uppercase;
}
.typed_text::before {
  content: attr(filter-content);
  filter: url(#motion-blur-filter);
}

svg {
  display: none;
}

.signIn {
  width: 100%;
  height: 100%;
  background-image: url("../../../../public/assets/img/pool-wallpaper-12.jpeg");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &_container {
    height: 100%;
    background-color: #0277bd;
    opacity: 0.9;
    display: flex;
    border-left: 1px solid white;
    align-items: center;
  }

  &_form {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // border: 1px solid white;
    border-radius: 4px;
    // box-shadow: 0 0 10px #004c8b;
    width: 100%;
    height: 45%;
    margin: 0 auto;
  }

  &_form-title {
    font-size: 40px;
    font-weight: bold;
    color: white;
    align-self: flex-start;
    margin-left: 2.5%;
    font-family: "Roboto";
  }

  &_form-flex {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &_form-email {
    width: 95%;

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
      -webkit-text-fill-color: white;
      -webkit-box-shadow: 0 0 0 30px #0277bd inset !important;
    }

    input:focus,
    input:active {
      color: white !important;
    }
  }

  &_form-pass {
    width: 95%;

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
      -webkit-text-fill-color: white;
      -webkit-box-shadow: 0 0 0 30px #0277bd inset !important;
    }

    input:focus,
    input:active {
      color: white !important;
    }
  }
}
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

.helper_text {
  color: white;
  font-weight: normal;
  margin: 10px auto;

  a {
    color: white;
    padding-left: 10px;
    margin-left: 10px;
    text-decoration: none;
    border-left: 1px solid white;
    transition: all 0.1s;
  }

  a:hover {
    text-shadow: 0 0 1px white;
    border: 1px solid white;
    padding: 3px 8px;
  }
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@media only screen and (max-width: 1264px) {
  .signIn {
    justify-content: flex-end;
  }
}

@media only screen and (max-width: 599px) {
  .signIn_container {
    border: none;
  }
}
</style>
